import { render, staticRenderFns } from "./MyCaseBookPage.vue?vue&type=template&id=6d817cbb&scoped=true&"
import script from "./MyCaseBookPage.vue?vue&type=script&lang=js&"
export * from "./MyCaseBookPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d817cbb",
  null
  
)

export default component.exports